
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.99 13.089L16.5 1.627a2.163 2.163 0 00-3.041 0L2.5 12.551l-.54.539C.29 14.755.855 16.122 3.218 16.122h.4V29.99h7.165v-8.867a1.072 1.072 0 011.076-1.073h6.229a1.072 1.072 0 011.076 1.073v8.867h7.162V16.117h.4c2.374 0 2.935-1.362 1.264-3.028z","fill":"#222"}})])
          )
        }
      }
    